import { GlobalEventEmitterService } from './service/global-event-emitter.service';
import { Message } from './utils/Message';
import { FunctionUtils } from './utils/FunctionUtils';
import { AbstractGs } from './service/AbstractGs';
import { SocketService } from './service/socket.service';
import { ApplicationControllerService } from './service/application-controller.service';
import { PermissionPricesService } from './service/permission-prices.service';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { BoostService } from './service/boost.service';
import { AchievementService } from './service/achievement.service';
import { ChangeEvent } from './events/ChangeEvent';
import { ICommand } from './controller/ICommand';
import { AlertWindowComponent } from './windows/alert-window/alert-window.component';
import { EventsSourceRunner } from './event-source/service/EventsSourceRunner';
import { RankingStats } from './event-source/utils/RankingStats';

export class AbstractAppComponent{
    public static SHOW_HIDE_WINDOW:string = "SHOW_HIDE_WINDOW";

    public static windowsParameters:Map<string, any> = new Map();
    protected windows:Map<string, string> = new Map();
    protected alertWindows:Map<string, AlertWindowComponent>;
    protected flashvars: any;

    public static totalRankingStats:RankingStats = new RankingStats( "TOTAL_SORTING_Viewport", null, 7, 7  );

    public static weeklyRankingStats:RankingStats = new RankingStats( "WEEKLY_SORTING_Viewport", null, 7, 7 );
    
    public static weeklyFriendsRankingStats:RankingStats = new RankingStats( "WEEKLY_FILTER_FRIENDS_Viewport", null, 7, 7 );
    
    public constructor(protected socketService:SocketService, protected applicationController:ApplicationControllerService, 
        protected gameService:AbstractGs, protected eventRunner:EventsSourceRunner, protected permissionPrices:PermissionPricesService, 
        protected achievementService:AchievementService, protected router: Router,
        protected boostService:BoostService,
        protected ngZone: NgZone){
      this.flashvars = JSON.parse(window['flashvars']);
      GlobalEventEmitterService.globalEmitter.subscribe( (e:ChangeEvent) => this.evaluateCommands(e));
    }

    windowVisible(name:string):boolean{
        //console.error("winVis: " + (this.windows[name] != null && this.windows[name] == true) );
        return this.windows[name] != null && this.windows[name] == "true";
    }

    logErrorStatus(statusFrom:String, statusTo:String):void
    {
      console.error("Bledny status, Status from: " + statusFrom + " -> " + statusTo);
      //sendError("BadStatus", "Bledny status", "Status from: " + statusFrom + " -> " + statusTo, "Status from: " + statusFrom + " -> " + statusTo);
    }

    evaluateCommands(event:ChangeEvent):void{
        this.currentMsg[ 0 ] = event.msg;
    
        let comm:ICommand = this.applicationController.getDomainCommand(event.msg);
        if( comm == null ){
          comm = this.applicationController.getDomainCommandForAll(event.msg);
        }
        if( comm == null){
          if( event.msg.name == EventsSourceRunner.EVENT_SOURCE_SG_NAME ){
            this.eventRunner.handleEventSourceEvent( event.msg );
            return;
          }
          if ( event.msg.name == EventsSourceRunner.EVENT_SOURCE_USER_ACTION) {
            this.socketService.sendMsg( event.msg );
            return;
          }
          if(event.msg.name == AbstractAppComponent.SHOW_HIDE_WINDOW){
            this.windows[event.msg.params[0]] = event.msg.params[1];
            if( event.msg.params[1] == 'true'){
              AbstractAppComponent.windowsParameters.set(event.msg.params[0], event.windowParams);
              if(this.alertWindows[event.msg.params[0]] != undefined  ){
                
                this.alertWindows[event.msg.params[0]].showWindowWithParams( event.windowParams );
              }
            }else{
              AbstractAppComponent.windowsParameters.delete(event.msg.params[0]);
              if(this.alertWindows[event.msg.params[0]] != undefined  ){
                this.alertWindows[event.msg.params[0]].hideWindow();
              }
            }        
            return;
          }
          if (event.msg.name != "rematchProposal" && event.msg.name != "destroyWaitingGame")
          {
            console.error("msg name:  " + event.msg + " " + event.msg.name);
            this.logErrorStatus(this.applicationController.getStatusAsString(), event.msg.name);
          }
          return;
        }
        comm.run( event.msg, new Array() );
        let view:String = this.applicationController.getView(event.msg);
        if( view != null ){
          this.router.navigate([view], { skipLocationChange: true });
          //throw new Error( "not impl " );
        }
        if( comm.getState(event.msg, new Array()) >= 0){
          this.applicationController.state = comm.getState(event.msg, new Array());
        }
      }

      currentMsg:Array<Message> = new Array<Message>();

  



      public createRefreshWindow():Function{
        return FunctionUtils.createFunction( this.refreshWindow, this );
      }
      public refreshWindow(thisParam:any):boolean{
        thisParam.router.navigate(["/"], { skipLocationChange: true });
        location.reload();
        return false;
      }
      public hideWindow():boolean{
        return true;
      }
      public createReccreateYesNoFunction(func:Function):Function{
        return FunctionUtils.createFunction(func, this.gameService)
      }
      public reconectYes(gs:AbstractGs):boolean
      {
        var reconnectMsg:Message = new Message();
        reconnectMsg.name = "reconnect";
        reconnectMsg.params = new Array();
        reconnectMsg.fromServer = false;
        reconnectMsg.sender = gs.user.getCurrentUser();
        GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", reconnectMsg));
        return true;
      }
      
      public reconectNo(gs:AbstractGs):boolean
      {
        var msg:Message = new Message();
        msg.fromServer = false;
        msg.name = "destroyGame";
        msg.params = new Array();
        msg.receiver = "server";
        msg.sender = gs.user.getCurrentUser();
        GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", msg));
        
        return true;
      }

      public hideWaitAchievementAndStartGame( gameRules:string, diagramType:string ):void{
        var msg:Message = new Message();
        msg.name = "showOfAchievementOnFbConfirmation";
        msg.params = new Array();
        msg.params[ 0 ] = gameRules;
        msg.params[ 1 ] = diagramType;
        GlobalEventEmitterService.globalEmitter.emit( new ChangeEvent("changeEvent", msg) );
      }
}
